import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { canUseDOM } from 'exenv';

/**
 * @private
 * @ignore
 * lazy loads bootstrapNikeShop, invokes it and defines NikeShop as a global property on window with the created instance
 *
 * @returns {Promise} a dynamic import promise that code splits the bigger chunks from the entry file, resolving the new NikeShop instance
 */
function init() {
  return _init.apply(this, arguments);
}
/**
 * @private
 * @ignore
 * defines initNikeShop as a global property on window
 */
function _init() {
  _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$import,
      bootstrapNikeShop,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./bootstrap-nike-shop.js'));
          });
        case 1:
          _yield$import = _context.sent;
          bootstrapNikeShop = _yield$import["default"];
          if (window.NikeShop === undefined) {
            bootstrapNikeShop.apply(void 0, _args);

            // NOTE - we are moving the tagging up here to avoid changing hash for bigger file
            Object.defineProperty(window.NikeShop, 'version', {
              value: process.env.PACKAGE_VERSION
            });
          }
          return _context.abrupt("return", window.NikeShop);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _init.apply(this, arguments);
}
export default function initNikeShop() {
  if (canUseDOM && window.initNikeShop === undefined) {
    Object.defineProperty(window, 'initNikeShop', {
      value: init
    });
  }
}